import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IoMdTrash } from 'react-icons/io'
import {
  CancelButton,
  DeleteImageDescription,
  DeleteImageText,
  DeleteButton,
} from './DeleteImages.styles'

export const DeleteImages: React.FC<{
  onClickDelete: () => void
  onClickCancel: () => void
}> = ({ onClickDelete, onClickCancel }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Box sx={{ border: '1px dashed #D4D4D4', m: '16px 24px', p: '16px' }}>
      <DeleteImageText>{t('container_order_detail.delete_image')}</DeleteImageText>
      <DeleteImageDescription>
        {t('container_order_detail.delete_image_description')}
      </DeleteImageDescription>
      <Box sx={{ textAlign: 'center', marginTop: '16px' }}>
        <CancelButton onClick={onClickCancel} sx={{ marginRight: '10px' }}>
          {t('container_order_detail.cancel')}
        </CancelButton>
        <DeleteButton onClick={onClickDelete} variant="outlined">
          <IoMdTrash size={'24px'} style={{ marginRight: '8px' }} />
          {t('container_order_detail.delete')}
        </DeleteButton>
      </Box>
    </Box>
  )
}
